// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__-Vo0p","sidebarContainer":"style_sidebarContainer__CBC+e","mainContent":"style_mainContent__Zv+Sk"};